module.exports = __webpack_public_path__ + "img/1120372515.9b118025.png";